/*
 * @Author: Wangchaoke
 * @Date: 2019-11-28 14:27:07
 * @LastEditTime: 2020-08-31 09:48:37
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xingmahui_front/src/assets/js/HFwxConfig.js
 */
import {is_weixin,getCookie} from '@/assets/js/common.js'
import wx from 'weixin-js-sdk'

// 分享
export default{
    wxShare:function(shareDataParams,obj,callback){
        var that=this;
        if(is_weixin()){
            obj.$http.get('/wechat/oauth2/getJSSDKConfig?url='+encodeURIComponent(location.href.split('#')[0]),{},res=>{
                wx.config({
                    debug: false,
                    appId: res.appId,
                    timestamp: res.timestamp,
                    nonceStr: res.nonceStr,
                    signature:res.signature,
                    openTagList: ["wx-open-launch-weapp"],
                    jsApiList: [
                        'checkJsApi',
                        // 'updateAppMessageShareData',
                        // 'updateTimelineShareData',
                        'onMenuShareTimeline', // 分享到朋友圈接口
                        'onMenuShareAppMessage' //  分享到朋友接口
                    ],

                });
                wx.ready(function () {
                        // 微信分享的数据
                        var shareData = {
                            link: shareDataParams.shareLink,
                            desc: shareDataParams.shareDesc,
                            title: shareDataParams.shareTitle,
                            imgUrl: shareDataParams.imgUrl,
                            success: function (res) {
                                that.sensorsFn(obj,shareDataParams)
                                setTimeout(function(){
                                    callback(res);
                                },500)
                            }
                        }
                        wx.onMenuShareTimeline(shareData);//分享到朋友圈
                        wx.onMenuShareAppMessage(shareData);//分享给朋友
                        // wx.updateAppMessageShareData(shareData);//分享给朋友和分享到QQ
                        // wx.updateTimelineShareData(shareData);//分享到朋友圈和分享到QQ空间
                })
            })
        }
    },
    sensorsFn(obj,shareDataParams){
        var id = getCookie('xmh_unionid');
        sensors.track('ShareSuccess', {
            page_name:obj.$route.meta.title,
            share_url:shareDataParams.shareLink,
            share_source:id,
            content_id:shareDataParams.contentId,
            share_to:'',
        });
    }
}